module.exports = __webpack_public_path__ + "img/vanity1.ec54933b.jpeg";